import _ from 'underscore';

import { naptimeForumTypes } from 'bundles/discussions/constants';

// TODO (dwinegar) when string serialization changes this will need to change
export default (
  parentPost: $TSFixMe,
  contextId: $TSFixMe,
  cml: $TSFixMe,
  forumType: $TSFixMe,
  isFollowingQuestion: $TSFixMe
) => {
  const idData = {};

  if (forumType === naptimeForumTypes.mentorForumType) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'mentorForumQuestionId' does not exist on... Remove this comment to see the full error message
    idData.mentorForumQuestionId = `${contextId}~${parentPost.questionId}`;
  } else if (forumType === naptimeForumTypes.groupForumType) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'groupForumQuestionId' does not exist on ... Remove this comment to see the full error message
    idData.groupForumQuestionId = `${contextId}~${parentPost.questionId}`;
  } else if (forumType === naptimeForumTypes.gradedDiscussionPrompt) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseItemForumQuestionId' does not exis... Remove this comment to see the full error message
    idData.courseItemForumQuestionId = parentPost.questionId;
  } else {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseForumQuestionId' does not exist on... Remove this comment to see the full error message
    idData.courseForumQuestionId = `${contextId}~${parentPost.questionId}`;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionFollowOverrideOption' does not e... Remove this comment to see the full error message
  idData.questionFollowOverrideOption = isFollowingQuestion;

  if (parentPost.type === 'answer') {
    if (forumType === naptimeForumTypes.gradedDiscussionPrompt) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'parentCourseItemForumAnswerId' does not ... Remove this comment to see the full error message
      idData.parentCourseItemForumAnswerId = _(parentPost.id.split('~')).rest().join('~');
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'parentForumAnswerId' does not exist on t... Remove this comment to see the full error message
      idData.parentForumAnswerId = `${contextId}~${parentPost.topLevelForumAnswerId}`;
    }
  }

  return {
    data: {
      content: cml,
      ...idData,
    },
  };
};
